module.exports = __webpack_public_path__ + "static/media/ic_warning.68c9eb34.svg";